import { type Tag } from '../types/cmsTypes';

import { __STAGING__ } from './constants';
import { slugify } from './slugify';

/**
 * Note: Tag `_id`s are pulled directly from the CMS.
 */

export const STORIES_TAG_ID = __STAGING__
  ? 'DP0Vy24TIobDs8EmkawaPi'
  : 'RThb8uQnPXbyxubh0ABdet';

export type FeaturedTag = Pick<Required<Tag>, '_id' | 'label' | 'slug'>;

export const FEATURED_TAGS: FeaturedTag[] = [
  {
    _id: __STAGING__ ? '47JjXOkaE5bnza2BOrkhat' : 'iv0GSS34L5t8xEA3RATNb7',
    label: "How To's",
  },
  {
    _id: __STAGING__
      ? '46c9c6b1-817f-4713-bbcc-b1fc73f884ce'
      : 'iv0GSS34L5t8xEA3RASLA1',
    label: 'Comparisons',
  },
  {
    _id: __STAGING__ ? 'b7h4ewEqvDREVt90pJMpQS' : 'RThb8uQnPXbyxubh0ABmW2',
    label: 'Expert Advice',
  },
  {
    _id: __STAGING__ ? 'b7h4ewEqvDREVt90pJMq78' : 'RThb8uQnPXbyxubh0AAZAO',
    label: 'Guides',
  },
  {
    _id: __STAGING__
      ? 'f440603b-f634-4772-8e4e-5b0719e563ce'
      : 'RThb8uQnPXbyxubh0ACYtD',
    label: 'Top Lists',
  },
].map(({ _id, label }) => ({
  _id,
  label,
  slug: { _type: 'slug', current: slugify(label) },
}));
